import createVueApp from '../../shared/vue/create-app';
import VueMultiselect from 'vue-multiselect';
import axios from 'axios';
import shared from '../../shared';
import {initLoginComponents, loginControl} from '../../components/login';
import initCustomControls from '../../components/custom-controls';
import {initNotificationSettings} from '../profile/notifications';
import {globalActions} from '../../store/global-actions';
import VueCountdown from '@chenfengyuan/vue-countdown';
import _u from '../../shared/utils';
import {store} from '../../store/global-store';
import {initHowItWorksPage} from './how-it-works';
import {initHowMuchItCostsPage} from './how-much-it-costs';
import {defineRule, Field, Form} from 'vee-validate';
import initEmailInput from '../../components/inputs/email-input';
import openPreviewMixin from '../../shared/vue/openPreviewMixin';
import initCustomInputsComponents from '../../components/inputs/custom-inputs';
import initSideMenuComponents from '../../components/side-menu';
import initEditableInputComponent from '../../components/inputs/editable-input';
import {regex, required} from '@vee-validate/rules';

defineRule('regex', regex);
defineRule('required', required);

const initLoginPage = (opts) => {
    const app = createVueApp({ // NOSONAR
        data() {
            return {
                loginMode: opts.loginMode,
                enteredEmail: opts.model ? opts.model.email : null,
                returnUrl: opts.model ? opts.model.returnUrl : null,
                // true when login in modal
                // false for static pages - Login and Register
                isNeedToUpdateReturnUrl: false,
                isBuyLocationMode: true,
            };
        },
        components: {
            VeeValidationFormContext: Form,
            ValidationField: Field,
        },
    });

    app.mixin(loginControl);
    initLoginComponents(app);
    initCustomControls(app);
    initCustomInputsComponents(app);
    initEmailInput(app);

    app.mount(opts.el);
};

const initSimplePage = (opts) => {
    const app = createVueApp({ // NOSONAR
        mixins: [openPreviewMixin],
        data() {
            return {
                isBuyLocationMode: true,
            };
        },
    });

    initLoginComponents(app);
    initCustomControls(app);
    initEmailInput(app);
    initCustomInputsComponents(app);

    app.mount('#app');
};

const infoPageButtonTypes = Object.freeze({
    error: 0,
});

const initInfoPage = (opts) => {
    const app = createVueApp({ // NOSONAR
        mixins: [openPreviewMixin],
        data() {
            return {
                isLinkActive: false,
                action: () => { },
                isBuyLocationMode: true,
                isActive: true,
            };
        },
        methods: {
            transformSecondsLabel(props) {
                Object.entries(props).forEach(([key, value]) => {
                    const word = _u.getLabelByCount(value,
                        opts.labels.secondSingle,
                        opts.labels.secondsTwo,
                        opts.labels.secondsMultiple);

                    props[key] = `${value} ${word}`;
                });

                return props;
            },

            startLinkTimer() {
                if (this.$refs.timerLink) {
                    this.isLinkActive = false;
                    setTimeout(() => {
                        this.isLinkActive = true;
                    }, opts.timerLinkInterval);
                }
            },
            startAutoRedirectTimer() {
                if (opts.redirectButton && opts.redirectButton.isAutoRedirectNeeded) {
                    setTimeout(() => {
                        window.location.href = opts.redirectButton.url;
                    }, opts.redirectButton.interval);
                }
            },
            handleClick(e) {
                if (this.isLinkActive) {
                    this.startLinkTimer();
                    const requestConfig = _u.createRequestConfig(opts.antiforgeryToken);
                    axios.post(opts.url, opts.payload, requestConfig)
                        .catch(() => window.location.href = opts.errorRedirectUrl);
                }
            },
            openFeedback() {
                store.commit('openFeedback', {type: opts.reportType});
            },
            setAction(actionButtonType) {
                if (actionButtonType === infoPageButtonTypes.error) {
                    this.action = this.openFeedback;
                }
            },
        },
        mounted() {
            this.startAutoRedirectTimer();
            this.startLinkTimer();
            if (opts.actionButtonType != null) {
                this.setAction(opts.actionButtonType);
            }
        },
    });
    app.component(VueCountdown.name, VueCountdown);

    initLoginComponents(app);
    initCustomControls(app);
    initCustomInputsComponents(app);

    app.mount('#app');
};

const confirmationEmailMixin = {
    data() {
        return {
            isEmailStepActive: false,
            isConfirmationCodeStepActive: true,
            isLinkActive: true,
            showErrors: false,
            labels: {},
            actualLabel: '',
        };
    },
    computed: {
        actionButtonResultText() {
            return `${this.model.actionButton.message}${this.actualLabel}`;
        },
    },
    methods: {
        setStartEmailEditMode() {
            this.isEmailStepActive = true;
            this.isConfirmationCodeStepActive = false;
        },

        setCancelEmailEditMode() {
            this.isEmailStepActive = false;
            this.isConfirmationCodeStepActive = true;
        },

        transformSecondsLabel(props) {
            Object.entries(props).forEach(([key, value]) => {
                const word = _u.getLabelByCount(value,
                    this.model.labels.secondSingle,
                    this.model.labels.secondsTwo,
                    this.model.labels.secondsMultiple);

                props[key] = `${value} ${word}`;
            });

            return props;
        },

        onEditClick() {
            this.setStartEmailEditMode();
            const editEmailComponent = this.$refs.emailEdit;
            if (!editEmailComponent.isEditMode) {
                editEmailComponent.startEdit();
            }
            editEmailComponent.$el?.scrollIntoView({behavior: 'smooth', block: 'center'});
        },

        onPossibleProblemClick() {
            const possibleProblem = this.$refs.possibleProblem;
            possibleProblem.scrollIntoView({behavior: 'smooth', block: 'center'});
        },

        async _validate(field) {
            this.showErrors = true;
            const validator = this.$refs.validator;
            const result = await validator.validateField(field);

            return result.valid;
        },

        startLinkTimer() {
            const oneSecond = 1000;
            if (this.$refs.timerLink) {
                this.isLinkActive = false;

                let counter = this.model.actionButton.interval / oneSecond;
                const timer = setInterval(() => {
                    this.actualLabel = this.labels[counter] ? this.labels[counter] : '';
                    --counter;
                    if (counter === 0) {
                        this.isLinkActive = true;
                        clearInterval(timer);
                        this.actualLabel = '';
                    }
                }, oneSecond);
            }
        },

        async sendUpdateEmail() {
            const valid = await this._validate('email');
            if (!valid) {
                globalActions.openInfoModal(this.model.errorDataTitle, this.model.errorDataBody);
            } else {
                if (this.actualEmail !== this.initialEmail) {
                    const url = _u.addQueryParamForUrl(this.model.resendEmailUrl, 'email', this.actualEmail);
                    try {
                        await axios.post(url);
                        this.initialEmail = this.actualEmail;
                        this.setCancelEmailEditMode();
                    } catch (err) {
                        this.handlerError(err);
                    }
                }
            }
        },

        onValidCodeAction() {
            window.location.href = this.model.returnUrl;
        },

        handlerError(error) {
            const errorText = error.response.data?.value ? error.response.data?.value : this.model.errorDataBody;
            globalActions.openInfoModal(this.model.errorDataTitle, errorText);
        },

        async onResendEmailClick() {
            if (this.isLinkActive) {
                const url = this.buildResendEmailUrl();

                try {
                    const response = await axios.post(url);

                    if (response.status === 200) {
                        if (!response.data.isEmailConfirmed) {
                            this.startLinkTimer();
                        }
                    } else {
                        globalActions.openInfoModal(this.model.errorDataTitle, this.model.errorDataBody);
                    }
                } catch (error) {
                    this.handleError(error);
                }
            }
        },
        buildResendEmailUrl() {
            return _u.addQueryParamForUrl(this.model.actionButton.url, 'email', this.actualEmail);
        },
    },
    mounted() {
        const values = Array.from(Array(this.model.actionButton.interval/1000).keys());
        this.labels = this.transformSecondsLabel(values);
    },
};

const initConfirmationEmailPage = (opts) => {
    const app = createVueApp({ // NOSONAR
        mixins: [confirmationEmailMixin],
        data() {
            return {
                model: opts.model,
                isLinkActive: true,
                showErrors: false,
                action: () => { },
                isBuyLocationMode: true,
                isConfirmationCodeStepActive: true,
                isEmailStepActive: false,
                initialEmail: opts.emailModel,
                actualEmail: opts.emailModel,
            };
        },
        components: {
            Field: Field,
            ValidationForm: Form,
        },
    });

    initLoginComponents(app);
    initCustomControls(app);
    initCustomInputsComponents(app);
    initSideMenuComponents(app);
    initEditableInputComponent(app);

    app.mount('#app');
};

const initNotVisiblePage = (opts) => {
    const app = createVueApp({ // NOSONAR
        methods: {
            makeVisible() {
                axios.post(opts.changeVisibilityUrl)
                    .then(() => window.location = opts.previewUrl)
                    .catch(globalActions.handleAjaxErrors);
            },
        },
    });

    initLoginComponents(app);
    initCustomControls(app);

    app.mount('#app');
};

const initInvitationAcceptedPage = (opts) => {
    const app = createVueApp({ // NOSONAR
        components: {
            Multiselect: VueMultiselect,
        },
        methods: {
            openFeedback() {
                globalActions.openFeedback();
            },
        },
    });

    initLoginComponents(app);
    initCustomControls(app);

    app.mount(opts.el);
};

export {
    shared,
    confirmationEmailMixin,
    initLoginPage,
    initSimplePage,
    initInfoPage,
    initConfirmationEmailPage,
    initNotVisiblePage,
    initInvitationAcceptedPage,
    initNotificationSettings,
    initHowItWorksPage,
    initHowMuchItCostsPage,
};
